import { render, staticRenderFns } from "./EDialogFormLaboratoryComp.vue?vue&type=template&id=710223d6&"
import script from "./EDialogFormLaboratoryComp.vue?vue&type=script&lang=js&"
export * from "./EDialogFormLaboratoryComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports